import { render, staticRenderFns } from "./FavoriteComponent.vue?vue&type=template&id=20bc4a41"
import script from "./FavoriteComponent.vue?vue&type=script&lang=js"
export * from "./FavoriteComponent.vue?vue&type=script&lang=js"
import style0 from "./FavoriteComponent.vue?vue&type=style&index=0&id=20bc4a41&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20bc4a41')) {
      api.createRecord('20bc4a41', component.options)
    } else {
      api.reload('20bc4a41', component.options)
    }
    module.hot.accept("./FavoriteComponent.vue?vue&type=template&id=20bc4a41", function () {
      api.rerender('20bc4a41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FavoriteComponent.vue"
export default component.exports